import { render } from "./VisionMissionView.vue?vue&type=template&id=60d03a55"
import script from "./VisionMissionView.vue?vue&type=script&lang=js"
export * from "./VisionMissionView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__